import update from 'immutability-helper'
import * as t from './actionTypes'

const initialState = {
  isConfirming: false,
  isFetching: true,
  // initialFetch has to be completed before objects can be fetched.
  initialFetch: false,
  errors: null,
  confirmed: false,
  criteria: {
    language: null,
    resource_id: null,
    arrival_date: null,
    duration: null,
    special_code: null,
    preferences: [],
    subjects: [],
    additions: []
  },
  customer: null,
  reservation_id: null,
  reservation_number: null,
  arrival_date: null,
  departure_date: null,
  book_date: null,
  status: null,
  total_price: null,
  customer_total_price: null,
  agent_total_price: null,
  bill_lines: [],
  reserved_resources: [],
  objects: [],
  sections: {
    current: null,
    previous: null,
    next: null
  },
  offer: null,
  // TODO: determine if this is the right place to keep filters
  filters: {
    addition_category: null,
    properties: {}
  },
  // Defined a default form for testing purposes. This is being overwritten by a reservationConfirmation
  payment_forms: []
  // payment_forms: {
  //   ogoneWhole: '<form method="post" action="https://secure.ogone.com/ncol/test/orderstandard_utf8.asp" id="ogoneWhole" name="ogoneWhole">        <input type="hidden" name="PSPID" value="opifer2"  /><input type="hidden" name="ORDERID" value="00517001742000"  /><input type="hidden" name="AMOUNT" value="44310"  /><input type="hidden" name="CURRENCY" value="EUR"  /><input type="hidden" name="EMAIL" value="hello@rickvanlaarhoven.nl"  /><input type="hidden" name="LANGUAGE" value="nl_NL"  /><input type="hidden" name="ACCEPTURL" value="http://vagrant.dev/app_dev.php/booking/payment-confirmation"  /><input type="hidden" name="CANCELURL" value="http://vagrant.dev/app_dev.php/booking/confirmation"  /><input type="hidden" name="PARAMPLUS" value="distributionchannelId=4041&amp;employeeId=4081&amp;concernId=7"  />   <input type="hidden" name="SHASIGN" value="932D1964712FA9DAF7F20B76D270C30683B3052E" /></form>'
  // },
}

const criteria = (state, action) => {
  switch (action.type) {
    case t.SET_RESERVATION_CRITERIA: {
      return {
        ...state,
        ...action.criteria
      }
    }
    default: {
      return state
    }
  }
}

const filters = (state, action) => {
  switch (action.type) {
    case t.SET_FILTERS: {
      return {
        ...state,
        ...action.filters
      }
    }
    case t.UPDATE_PROPERTY_COUNTS: {
      return Object.assign({}, state, {
        properties: action.properties
      })
    }
    case t.SET_ADDITION_CATEGORY: {
      return {
        ...state,
        addition_category: action.category
      }
    }
    default: {
      return state
    }
  }
}

const sections = (state, action) => {
  switch (action.type) {
    case t.SET_INITIAL_SECTIONS: {
      return {
        ...state,
        current: action.current,
        next: action.next
      }
    }
    case t.SET_NEXT_SECTION: {
      const bookingSections = action.sections
      const idx = bookingSections.findIndex(s => s.id === state.current.id)
      return {
        ...state,
        previous: state.current,
        current: state.next,
        next: bookingSections[idx + 2]
      }
    }
    case t.SET_CURRENT_SECTION: {
      const bookingSections = action.sections
      const idx = bookingSections.findIndex(s => s.id === action.current.id)

      return {
        ...state,
        previous: (bookingSections[idx - 1]) ? bookingSections[idx - 1] : null,
        current: action.current,
        next: (bookingSections[idx + 1]) ? bookingSections[idx + 1] : null
      }
    }
    case t.PREVIOUS_SECTION: {
      return {
        ...state
      }
    }
    default: {
      return state
    }
  }
}

const reservation = (state = initialState, action) => {
  switch (action.type) {
    case t.RESERVATION_INITIAL_FETCH: {
      return {
        ...state,
        initialFetch: action.payload
      }
    }
    case t.SET_OFFER: {
      return {
        ...state,
        offer: action.offer
      }
    }
    case t.SET_OBJECTS: {
      return {
        ...state,
        objects: action.payload.objects
      }
    }
    case t.CLEAR_RESERVATION: {
      return initialState
    }
    case t.RESERVATION_PROPOSAL_START: {
      return {
        ...state,
        isFetching: true
      }
    }
    case t.RESERVATION_PROPOSAL_SUCCESS: {
      return {
        ...state,
        ...action.reservation,
        errors: null,
        criteria: Object.assign({}, state.criteria, action.criteria),
        isFetching: false
      }
    }
    case t.RESERVATION_PROPOSAL_FAILURE: {
      return {
        ...state,
        isFetching: false,
        errors: action.errors
      }
    }
    case t.RESERVATION_CONFIRMATION_START: {
      return {
        ...state,
        isConfirming: true
      }
    }
    case t.RESERVATION_CONFIRMATION_SUCCESS: {
      return {
        ...state,
        ...action.reservation,
        errors: null,
        confirmed: true,
        criteria: {
          ...state.criteria,
          ...action.criteria
        },
        isFetching: false,
        isConfirming: false
      }
    }
    case t.RESERVATION_CONFIRMATION_FAILURE: {
      return {
        ...state,
        isConfirming: false,
        errors: action.errors
      }
    }
    case t.SET_RESERVATION_CRITERIA: {
      return Object.assign({}, state, {
        criteria: criteria(state.criteria, action)
      })
    }
    case t.SET_CUSTOMER: {
      return Object.assign({}, state, {
        customer: action.customer
      })
    }
    case t.SET_ADDITION_CATEGORY:
    case t.UPDATE_PROPERTY_COUNTS:
    case t.SET_FILTERS: {
      return Object.assign({}, state, {
        filters: filters(state.filters, action)
      })
    }
    case t.SET_INITIAL_SECTIONS:
    case t.SET_CURRENT_SECTION:
    case t.SET_NEXT_SECTION:
    case t.PREVIOUS_SECTION: {
      return Object.assign({}, state, {
        sections: sections(state.sections, action)
      })
    }
    case t.SET_SECTION:
      if (state.sections.current && state.sections.current.id === action.payload.current.id) {
        return state
      }
      return update(state, {
        sections: {
          previous: {
            $set: action.payload.previous
          },
          current: {
            $set: action.payload.current
          },
          next: {
            $set: action.payload.next
          }
        }
      })
    default: {
      return state
    }
  }
}

export default reservation
